import { render } from "./Honorarios.vue?vue&type=template&id=a238c468&scoped=true&ts=true"
import script from "./Honorarios.vue?vue&type=script&lang=ts"
export * from "./Honorarios.vue?vue&type=script&lang=ts"

import "./Honorarios.vue?vue&type=style&index=0&id=a238c468&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a238c468"]])

export default __exports__